import styled from 'styled-components';

export const colors = {
    bg:      '#3C3C3C',
    surface: '#FFFFFF',
    panel:   '#3C3C3C',
    border:  '#3C3C3C',
    accent:  '#F8FAFC',
    text:    '#FFFFFF',
    muted:   '#555555',
    mono:    '"Segoe UI", Tahoma, sans-serif',
    sans:    '"Segoe UI", Tahoma, sans-serif',
};

export const ImageViewerWrapper = styled.div`
    display:  flex;
    flex-direction: column;
    height: 100vh;
    background: ${colors.bg};
    color: ${colors.text};
    font-family: Roboto sans-serif;
    user-select: none;
    overflow: hidden;
    border: 8px solid ${colors.border};
`;

export const NoImageViewer = styled.div`
    flex: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const NoImageInfo = styled.span`
    font-family: ${colors.mono};
    font-size: 12px;
    color: ${colors.muted};
`;

export const ImageViewerToolbar = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 14px;
    height: 46px;
    background: ${colors.panel};
    flex-shrink: 0;
    border-bottom: 1px solid ${colors.border};
`;

export const StyledIconButton = styled.button`
    background: transparent;
    border: 1px solid ${colors.border};
    border-radius: 6px;
    color: ${colors.text};
    cursor: pointer;
    width: 32px;
    height: 30px;
    font-size: 18px;
    line-height: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const StyledToolButton = styled.button`
    background: transparent;
    border: 1px solid ${colors.border};
    border-radius: 5px;
    color: ${colors.text};
    cursor: pointer;
    font-size: 11px;
    height: 30px;
    padding: 0 11px;
    white-space: nowrap;
    letter-spacing: 0.03em;
    flex-shrink: 0;
`;

export const StyledZoomInfo = styled.span`
    font-family: ${colors.mono};
    font-size: 12px;
    color: ${colors.accent};
    height: 30px;
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const StyledZoomSliderWrapper = styled.div`
    position: relative;
    flex: 0 0 180px;
    height: 4px;
    background: ${colors.border};
    border-radius: 2px;
`;

export const StyledZoomSlider = styled.div<{$width: string}>`
    position: absolute;
    top: 0;
    left: 0;
    height: 4px;
    width: ${props => props.$width};
    background: ${colors.accent};
    border-radius: 2px;
    transition: width 0.2s ease-in-out;
    pointer-events: none;
`

export const StyledZoomSliderElement = styled.input`
    position: absolute;
    top: -10px;
    left: -4px;
    width: calc(100% + 8px);
    height: 24px;
    opacity: 0;
    cursor: pointer;
`;

export const StyledImageView = styled.img<{ $zoom: number }>`
    display: block;
    max-width: none;
    image-rendering: ${props => props.$zoom >= 4 ? 'pixelated' : 'auto'};
`;